/* eslint-disable no-alert */
import {Button, Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {Image, StyleSheet, Linking, View} from 'react-native';
import {telegramIcon, whatsAppIcon} from '../../../../assets/images';
import {px} from '../../../../utils';

const TelegramGroupsCard = ({user}) => {
  const handleOpenLink = async (url) => {
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
    } else {
      alert(`Don't know how to open this URL: ${url}`);
    }
  };

  return (
    <Layout style={styles.container}>
      <Text style={styles.trailHeading}>
        {'Join WhatsApp & Telegram groups'}
      </Text>
      <View style={styles.socialIcons}>
        <Image style={styles.icon} source={telegramIcon} resizeMode="contain" />
        <Image
          style={styles.whatsappIcon}
          source={whatsAppIcon}
          resizeMode="contain"
        />
      </View>
      <Text style={styles.text}>
        {'Announcements will be given in WhatsApp & Telegram groups.'}
      </Text>
      <Button
        style={styles.button}
        onPress={() => handleOpenLink(user?.telegramLink)}>
        {'Join WhatsApp & Telegram Groups'}
      </Button>
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: px(20),
    marginHorizontal: 31,
    paddingHorizontal: px(17),
    paddingTop: px(22),
    paddingBottom: px(20),
    borderColor: '#3A86FF',
    borderWidth: 2,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4.65,

    elevation: 8,
  },
  socialIcons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    marginTop: 15,
  },
  trailHeading: {
    fontSize: px(16),
    fontWeight: '700',
    textAlign: 'center',
  },
  text: {
    marginTop: px(17),
    fontSize: px(16),
    textAlign: 'center',
  },
  button: {
    width: '100%',
    marginTop: px(17),
  },
  icon: {
    width: 30,
    height: 30,
  },
  whatsappIcon: {
    width: 40,
    height: 40,
  },
});

export default TelegramGroupsCard;
